import { render } from "./BioSlider.vue?vue&type=template&id=7558fbc7"
import script from "./BioSlider.vue?vue&type=script&lang=js"
export * from "./BioSlider.vue?vue&type=script&lang=js"

import "./BioSlider.vue?vue&type=style&index=0&id=7558fbc7&lang=css"
script.render = render

export default script